import { configureApi, type PlatformBridge } from '@packages/api';
import { isTokenExpired } from '@packages/auth';
import { API_URL } from './config';
import { clearAllDashboardChatPersistence } from './dashboard-chat-persistence';

const TOKEN_KEY = 'bill_auth_token';

const webBridge: PlatformBridge = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (token: string) => localStorage.setItem(TOKEN_KEY, token),
  removeToken: () => {
    localStorage.removeItem(TOKEN_KEY);
    // The dashboard remembers the active conversation across refreshes within
    // a session; an auth-state clear ends that session, so wipe the pointer
    // too. Every logout path (manual, expired token, 401 redirect, account
    // deletion) funnels through removeToken, so this single hook covers all.
    clearAllDashboardChatPersistence();
  },
  hasValidSessionToken: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return token === null ? true : !isTokenExpired(token);
  },
  onUnauthorized: () => {
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    const loginUrl = currentPath && currentPath !== '/'
      ? `/login?redirect=${encodeURIComponent(currentPath)}`
      : '/login';
    window.location.href = loginUrl;
  },
  onPaymentRequired: () => {
    window.dispatchEvent(new CustomEvent('bill:payment-required'));
  },
  generateUUID: () => crypto.randomUUID(),
};

export function initializeApi(): void {
  configureApi({ apiUrl: API_URL, bridge: webBridge });
}
